module.exports = __webpack_public_path__ + "static/img/chainBigData.fbcfc6ba.svg";